import React from "react";
import logo from "../../assets/img/theme/blinx.png"; // Ensure the correct path

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer style={{ textAlign: "center", fontSize: "12px", lineHeight: "1", marginTop: "5px" }}>
            <img src={logo} alt="BLiNX Logo" style={{ height: "16px", verticalAlign: "middle" }} />
            <span> &copy; {currentYear} BLiNX Lanka (PVT) LTD.| College Management System - Mini ERP by BLiNX. All Rights Reserved.</span>
            <a href="mailto:info@blinx.lk" style={{ marginLeft: "5px" }}>info@blinx.lk</a>
        </footer>
    );
};

export default Footer;
